import { Component } from '@angular/core'
import { SitesService } from '../../../services/sites.service';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss']
})

export class SiteListComponent {
  sites;
  displayedColumns = ['label'];
  constructor(
    private sitesService: SitesService
  ) {}

  ngOnInit() {
    this.sitesService.getSites().subscribe(result=> {
      this.sites = result;
    })
  }
}